import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type BreadCrumbsContainerProps = {
	className?: string;
	children: React.ReactNode | JSX.Element;
};

export const BreadCrumbsContainer = ({
	children,
	className,
}: BreadCrumbsContainerProps) => {
	return (
		<div className={clsx(styles.breadCrumbsContainer, className)}>
			{children}
		</div>
	);
};
